//@flow

// Vendors
import React, { useState, useContext, createContext, useRef } from 'react';

// Components
import { Button, TextButton, ButtonIcon } from 'texkit/dist/components/Buttons';
import * as Transitions from '../..';

// Types
type Props = {
  className?: string,
  children: Node,
};

type DrawerContextType = {
  open: boolean,
  toggle?: Function,
  setHeight?: Function,
};

const DrawerContext = createContext<DrawerContextType>({ open: false });

function Drawer(props: Props) {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(isOpen => !isOpen);
  return <DrawerContext.Provider value={{ open, toggle }} {...props} />;
}

function Open({
  transition = 'DrawerTransition',
  ...props
}: {
  transition: string,
}) {
  const Transition = Transitions[transition];
  const transitionRef = useRef();
  const [height, set] = useState(0);
  const setHeight = height =>
    set(
      typeof height === 'number'
        ? height
        : transitionRef.current && transitionRef.current.scrollHeight
    );
  const { open } = useContext(DrawerContext);
  const style = { maxHeight: height };
  return (
    <div ref={transitionRef}>
      <Transition
        in={open}
        onEnter={() => setHeight()}
        onExiting={() => setHeight(0)}
        style={style}
        {...props}
      />
    </div>
  );
}

function Toggle({ as, ...props }: { as: string }) {
  const { toggle } = useContext(DrawerContext);
  const components = { Button, TextButton, ButtonIcon };
  const T = components[as] || as;
  return <T {...props} onClick={toggle} />;
}

Drawer.Open = Open;
Drawer.Toggle = Toggle;

export default Drawer;
